import ServiceCRUD from '../../../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/filas');
  }
}

export default new Service();
